import { useState, useRef } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { ChevronLeft } from "lucide-react";

import "./VerifyEmailForm.css";

import service from "../../services/service";
import endpoints from "../../services/endpoints";

export default function VerifyEmailForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state?.email;
  const purpose = location?.state?.purpose;
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const [isLoading, setIsLoading] = useState(false);

  const inputRefs = useRef([]);

  const handleOtpChange = (index, value) => {
    if (value.length > 1) return;

    if (value && !/^\d+$/.test(value)) return;

    const newOtp = [...otp];

    newOtp[index] = value;

    setOtp(newOtp);
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handleVerify = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);

      const finalOtp = otp.join("");

      const payload = {
        email,
        otp: Number(finalOtp),
        purpose,
      };

      const res = await service.post(endpoints.auth.verifyEmail, payload);
      const isSuccess = res?.status === 200 || res?.status === 201;

      if (!isSuccess) {
        return;
      }

      if (purpose === "forgot-password") {
        const token = res?.data?.data?.resetToken;
        if (!token) {
          return;
        }

        navigate("/reset-password", {
          state: {
            email,
            token,
          },
        });
      } else {
        navigate("/login");
      }
    } catch (error) {
      console.log("VERIFY ERROR", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      const payload = {
        email,
      };

      const res = await service.post(endpoints.auth.resendOtp, payload);

      const isSuccess = res?.status === 200 || res?.status === 201;

      if (!isSuccess) {
        return;
      }
    } catch (error) {
      console.log("RESEND OTP ERROR", error);
    }
  };

  return (
    <div className="login-form-wrapper">
      {/* Back Button */}
      <Link
        to={purpose === "forgot-password" ? "/forget-password" : "/signup"}
        className="forgot-back-btn"
      >
        <ChevronLeft size={20} />
        <span>Back</span>
      </Link>

      {/* Heading */}
      <div className="login-heading">
        <h1>Verify Your Email</h1>

        <p>
          We have sent OTP to <strong>{email}</strong>
        </p>
      </div>

      {/* Form */}
      <form className="login-form" onSubmit={handleVerify}>
        <div className="otp-group">
          <div className="otp-inputs">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                placeholder="-"
                className="otp-input"
              />
            ))}
          </div>

          {/* Resend */}
          <p className="resend-text">
            Didn&apos;t receive code?{" "}
            <button
              type="button"
              className="resend-btn"
              onClick={handleResendOtp}
            >
              Resend
            </button>
          </p>
        </div>

        {/* Verify Button */}
        <button type="submit" className="auth-login-btn" disabled={isLoading}>
          {isLoading ? "Verifying..." : "Verify"}
        </button>
      </form>
    </div>
  );
}
